import { render, staticRenderFns } from "./access-denied.vue?vue&type=template&id=4b18b7bd"
import script from "./access-denied.vue?vue&type=script&lang=js"
export * from "./access-denied.vue?vue&type=script&lang=js"
import style0 from "./access-denied.vue?vue&type=style&index=0&id=4b18b7bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports